module.exports = __webpack_public_path__ + "media/components/assets/images/cooingklePackage/cta1_sale2-e30bc64c37a4f9fe4127bad1b99273bb.png";